<script lang="ts">
import MainPage from "@/Components/MainPage.vue";
import App from "@/Layouts/App.vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        MainPage,
    },
    layout: App,
    props: {},
    emits: [],
    data: () => ({}),
    computed: {},
    methods: {},
});
</script>

<template>
    <MainPage title="Impressum" :gap="true">
        <div class="flex flex--v flex--valign-c flex--gap-40">
            <div class="flex flex--v flex--valign-c flex--gap-10">
                <span class="text text--size-18 text--primary-b text--center text--semi-bold">Herausgeberin</span>
                <span class="text text--size-18 text--primary-b text--center text--less-gap">Stadt Oldenburg (Oldb)</span>
                <span class="text text--size-18 text--primary-b text--center text--less-gap">Der Oberbürgermeister</span>
                <span class="text text--size-18 text--primary-b text--center text--less-gap">26105 Oldenburg</span>
            </div>

            <div class="flex flex--v flex--valign-c flex--gap-10">
                <span class="text text--size-18 text--primary-b text--center text--less-gap">Verantwortlich im Sinne von § 5 Telemediengesetz (TMG) und § 55 Rundfunkstaatsvertrag (RStV):</span>
                <span class="text text--size-18 text--primary-b text--center text--less-gap">Stadt Oldenburg (Oldb), Amt für Schule und Bildung</span>
                <span class="text text--size-18 text--primary-b text--center text--less-gap">Bergstraße 25, 26122 Oldenburg (Oldb)</span>
            </div>
        </div>
    </MainPage>
</template>

<style lang="scss" scoped>
.impressum {
    padding: 20px;
}
</style>
